module.exports = __webpack_public_path__ + "static/oslo-efe2957ff738a0551c5e473b2ffcffd5.jpg";